export const traitIdToResourceId: Record<number, number> = {
  7000201: 11100,
  7000301: 11200,
  7000401: 11300,
  7000501: 11400,
  7000601: 11500,
  7010101: 12100,
  7010201: 12300,
  7010301: 12400,
  7010311: 12900,
  7010401: 12500,
  7010501: 12200,
  7010601: 12600,
  7010701: 12700,
  7010801: 13000,
  7100101: 21100,
  7100201: 21200,
  7100301: 21300,
  7100401: 21400,
  7100501: 21500,
  7110101: 22100,
  7110201: 22200,
  7110301: 22400,
  7110401: 22300,
  7110501: 22500,
  7110601: 22600,
  7110701: 22700,
  7110801: 22900,
  7110901: 22800,
  7200101: 31100,
  7200201: 31300,
  7200301: 31200,
  // 7200401: 31300, 왜 겹치는 아이디가 할당되었는지 모름
  7200501: 31400,
  7210101: 32100,
  // 7210201: 32200, 1.8에서 리소스 없음
  7210301: 32400,
  7210401: 32300,
  7210501: 32500,
  7210601: 32600,
  7210801: 32800,
  7211001: 32700,
};
